































































































































import { Vue, Component } from "vue-property-decorator";
import SideBar from "@/zh-website/src/components/website/SideBar.vue";
@Component({
  components: { SideBar }
})
export default class Fives extends Vue {
  setSelcted(index) {
    (this.$refs.carousel as any).setActiveItem(index);
  }
}
